import styled from 'styled-components'
import { theme } from '../../../../../styles/theme'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Question = styled.p`
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.medium};
  line-height: ${theme.font.sizes.large};
  color: #42425D;
`

export const RatingWrapper = styled.div`
  display: flex;
  align-items: center;

  & > span {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.small};
    line-height: ${theme.font.sizes.normal};
    color: ${theme.colors.mediumGray};
    margin-right: 3px;
  }
`

export const Rating = styled.div``
